import React from 'react'
// import PropTypes from 'prop-types'
import Moment from 'moment'
import {Link} from 'react-router-dom'
import Icon from '../Icon'
import Caption from '../Caption'
import Button from '../Button'
import './News.sass'
import Col from "../Col"
import Container from "../Container"

const News = ({posts}) => {
  if (!posts){
    return null
  }
  return (
    <section className="news-wrapper">
      <Container>
        <Col xs={6} sm={12} md={24} lg={24}>
          <Caption>Информационные материалы</Caption>
          <div className="titleWrapper">
            <Link to='/' className="titleWrapper">
              <Button bsStyle='arrow-left' bsSize="lg">На главную</Button>
            </Link>
          </div>
          {posts &&
            <div className="news-wrapper">
              {posts.map(news => (
                <Link key={news.id} to={`/posts/${news.id}`} className="news">
                  <span className="news__date">
                    <span className="date__clock-wrapper">
                      <Icon type='clock' />
                    </span>
                    {Moment(news.created_at).format("DD MMMM YYYY")}
                  </span>
                  <h4 className={`news__caption ${!news.description && 'news__caption_padding'}`}>{news.caption}</h4>
                  {news.description &&
                    <p className="news__text">{news.description}</p>
                  }
                </Link>
              ))}
            </div>
          }
        </Col>
      </Container>
    </section>
  )
}

News.propTypes = {
  // posts: PropTypes.shape({
  //   id: PropTypes.number,
  //   created_at: PropTypes.string,
  //   caption: PropTypes.string,
  //   description: PropTypes.string
  // }).isRequired
}

export default News



// WEBPACK FOOTER //
// ./components/News/index.jsx